
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
    props: {},
})
export default class LegacyModal extends Vue {
    @Prop() title!: string;
    @Prop() minWidth!: string;
    @Prop() maxWidth!: string;
    @Prop() cancelButton!: boolean;

    @Prop() showFooter = true;
    @Prop() success = false;
}
